import { buildEndpoint, buildEndpointWithParams, buildEndpointWithQuery } from './base.endpoints';
import type { ID } from '../types';

const BASE_PATH = '/StateProvinces';

export const stateProvinceEndpoints = {
  list: () => buildEndpoint(BASE_PATH),
  getById: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
  byCountry: (countryId: string) => buildEndpointWithQuery(BASE_PATH, { countryId }),
  basePath: () => BASE_PATH,
} as const;

export default stateProvinceEndpoints;
